import { useState } from "react";

import arrowOutwardWhite from "@/assets/images/user/arrowOutwardWhite.svg";
import icAward1 from "@/assets/images/user/icAward1.svg";
import icAward2 from "@/assets/images/user/icAward2.svg";
import icAward3 from "@/assets/images/user/icAward3.svg";
import icAward4 from "@/assets/images/user/icAward4.svg";
import icAward5 from "@/assets/images/user/icAward5.svg";
import soundtrack2024Img1 from "@/assets/images/user/soundtrack2024Img1.png";
import soundtrack2024Img2 from "@/assets/images/user/soundtrack2024Img2.png";
import soundtrack2024Img3 from "@/assets/images/user/soundtrack2024Img3.png";
import soundtrack2024Img4 from "@/assets/images/user/soundtrack2024Img4.png";
import soundtrack2024Img5 from "@/assets/images/user/soundtrack2024Img5.png";
import soundtrack2024Img6 from "@/assets/images/user/soundtrack2024Img6.png";
import soundtrack2024Img7 from "@/assets/images/user/soundtrack2024Img7.png";
import soundtrack2024Img8 from "@/assets/images/user/soundtrack2024Img8.png";
import soundtrack2024Img9 from "@/assets/images/user/soundtrack2024Img9.png";
import soundtrack2024Img10 from "@/assets/images/user/soundtrack2024Img10.png";
import soundtrack2025Img1 from "@/assets/images/user/soundtrack2025Img1.jpg";
import soundtrack2025Img2 from "@/assets/images/user/soundtrack2025Img2.jpg";
import soundtrack2025Img3 from "@/assets/images/user/soundtrack2025Img3.jpg";
import soundtrack2025Img4 from "@/assets/images/user/soundtrack2025Img4.jpg";
import soundtrack2025Img5 from "@/assets/images/user/soundtrack2025Img5.jpg";
import soundtrack2025Img6 from "@/assets/images/user/soundtrack2025Img6.jpg";
import soundtrack2025Img7 from "@/assets/images/user/soundtrack2025Img7.jpg";
import soundtrack2025Poster from "@/assets/images/user/soundtrack2025Poster.jpg";
import soundtrack2025TxtImg from "@/assets/images/user/soundtrack2025TxtImg.svg";
import soundtrackPoster from "@/assets/images/user/soundtrackPoster.jpg";
import soundtrackTxtImg from "@/assets/images/user/soundtrackTxtImg.svg";
import SubTitle from "@/components/user/common/SubTitle";
import TitleBox from "@/components/user/common/TitleBox";

const awardGradient: Record<string, string> = {
    대상: "linear-gradient(180deg, #EB0771 0%, #850440 100%)",
    금상: "linear-gradient(180deg, #EB8E03 0%, #855002 100%)",
    은상: "linear-gradient(180deg, #9C8E8E 0%, #363131 100%)",
    동상: "linear-gradient(180deg, #654F42 0%, #CB9E84 100%)",
};

// 2025 경연대회 본선 무대
const stage2025LargeList = [
    {
        award: "대상",
        team: "우주골치클럽",
        song: "Hollow’s Puppet",
        game: "P의 거짓",
        img: soundtrack2025Img1,
        link: "https://youtu.be/MOQP7ZkNzbY?si=pdyN80iiJb1-35sO",
    },
    {
        award: "금상",
        team: "ON:明(온명)",
        song: "여명: 舁明",
        game: "검은사막",
        img: soundtrack2025Img2,
        link: "https://youtu.be/OuLiFmc-WAs?si=AiWWj0V8AKQZmbqR",
    },
    {
        award: "은상",
        team: "EZ DO BAND",
        song: "Sync or Sink",
        game: "리그오브레전드",
        img: soundtrack2025Img3,
        link: "https://youtu.be/G4nBTIJ3g2w?si=jdCtEGSTsU9S59VZ",
    },
    {
        award: "은상",
        team: "겜블러",
        song: "잿팟!",
        game: "모바일 한게임 포커",
        img: soundtrack2025Img4,
        link: "https://youtu.be/3pjE021yLMA?si=fx06HjXdqEstbZbH",
    },
];

const stage2025SmallList = [
    {
        award: "동상",
        team: "Band 203",
        song: "Up!",
        game: "브롤스타즈",
        img: soundtrack2025Img5,
        link: "https://youtu.be/peWs-VCDa8s?si=IiXohTRcn_U-ZZbp",
    },
    {
        award: "동상",
        team: "버닝",
        song: "두고 봐 빛날 거야",
        game: "메이플스토리",
        img: soundtrack2025Img6,
        link: "https://youtu.be/VMbzw0UvQcg?si=92aHD_qFaB7bJ7Fc",
    },
    {
        award: "동상",
        team: "볼따구프렌즈",
        song: "Be Fine!",
        game: "트릭컬 리바이브",
        img: soundtrack2025Img7,
        link: "https://youtu.be/2s1hzYDDz30?si=khqe2f4dV3YS5okv",
    },
];

type StageItem = {
    award: string;
    team: string;
    song: string;
    game: string;
    img: string;
    link: string;
};

function StageCard({ item, large = false }: { item: StageItem; large?: boolean }) {
    return (
        <div className="flex flex-col gap-[16px] md:gap-[20px]">
            <div className="flex items-center gap-[16px]">
                <div className="w-[76px] shrink-0 rounded-[8px] border border-[#E64C88] bg-[#ffffff14] py-[8px] text-center text-[20px] font-[500] leading-[1.6] tracking-[-0.25px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] md:w-[120px] md:text-[24px]">
                    <p
                        className="font-['GongGothicMedium']"
                        style={{
                            background: awardGradient[item.award] ?? "black",
                            backgroundClip: "text",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                        }}
                    >
                        {item.award}
                    </p>
                </div>
                <p
                    className={`font-['GongGothicBold'] text-[20px] text-black ${large ? "md:text-[28px]" : "md:text-[24px]"}`}
                >
                    {item.team}
                </p>
            </div>
            <div className="group relative aspect-video w-full">
                <div className="absolute inset-0 z-[2] rounded-[16px_0_16px_0] transition-all duration-500 after:absolute after:inset-0 after:z-[1] after:rounded-[16px_0_16px_0] after:bg-[linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] after:opacity-0 after:transition-all after:duration-500 after:content-[''] group-hover:p-[4px] group-hover:shadow-[0_0_36px_0_rgba(237,6,115,0.60)] group-hover:after:opacity-100 md:rounded-[20px_0_20px_0] md:after:rounded-[20px_0_20px_0]">
                    <div className="relative z-[2] h-full w-full overflow-hidden rounded-[16px_0_16px_0] md:rounded-[20px_0_20px_0]">
                        <a
                            href={item.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="relative block after:absolute after:inset-0 after:z-[1] after:bg-[rgba(0,0,0,0.4)] after:opacity-0 after:transition-all after:duration-500 after:content-[''] hover:after:opacity-100"
                        >
                            <img
                                src={item.img}
                                alt={`${item.team} - ${item.song}`}
                                width={690}
                                height={388}
                                className="h-full w-full object-cover transition-all duration-500 xl:group-hover:scale-[1.2]"
                            />
                            <p className="absolute left-1/2 top-1/2 z-[2] flex -translate-x-1/2 -translate-y-1/2 items-center justify-center gap-[12px] font-['GongGothicMedium'] text-[20px] text-white opacity-0 transition-all duration-500 group-hover:opacity-100 md:text-[24px]">
                                다시보기
                                <img src={arrowOutwardWhite} alt="다시보기" />
                            </p>
                        </a>
                    </div>
                </div>
            </div>
            <div className="flex flex-col gap-[8px]">
                <div className="flex items-center gap-[8px]">
                    <div className="flex w-[140px] shrink-0 items-center gap-[12px]">
                        <span className="block size-[8px] shrink-0 rotate-45 bg-black" />
                        <p className="whitespace-nowrap font-['GongGothicMedium'] text-[18px] text-black">곡명</p>
                    </div>
                    <p className="font-['GongGothicLight'] text-[16px] text-black md:text-[20px]">{item.song}</p>
                </div>
                <div className="flex items-center gap-[8px]">
                    <div className="flex w-[140px] shrink-0 items-center gap-[12px]">
                        <span className="block size-[8px] shrink-0 rotate-45 bg-black" />
                        <p className="whitespace-nowrap font-['GongGothicMedium'] text-[18px] text-black">
                            모티브 게임
                        </p>
                    </div>
                    <p className="font-['GongGothicLight'] text-[16px] text-black md:text-[20px]">{item.game}</p>
                </div>
            </div>
        </div>
    );
}

// 2024 경연대회 본선 무대
const awardList = [
    {
        award: "대상",
        title: "리프(Lif)",
        link: "https://youtu.be/C3TfBABAizg?si=jAD7hSmTP99BWd3v",
        img: soundtrack2024Img1,
    },
    {
        award: "금상",
        title: "Run into Galaxy",
        link: "https://youtu.be/DD1DcUwKENs?si=mBrd2x8CgZVjcXQE",
        img: soundtrack2024Img2,
    },
    {
        award: "은상",
        title: "Keepro & SUZNN",
        link: "https://youtu.be/APSkOoqaRSI?si=genyWwMtJCtxJklj",
        img: soundtrack2024Img3,
    },
    {
        award: "은상",
        title: "e-dust",
        link: "https://youtu.be/4OY8plZQ1Dk?si=MhRglkFGLLHwbmb9",
        img: soundtrack2024Img4,
    },
    {
        award: "동상",
        title: "데마시아",
        link: "https://youtu.be/lmxXpwkCsMo?si=AkacKxwTfgdZV0By",
        img: soundtrack2024Img5,
    },
    {
        award: "동상",
        title: "목화",
        link: "https://youtu.be/kKWkd1PLbeE?si=IoOmJ5_-GYzyElnl",
        img: soundtrack2024Img6,
    },
    {
        award: "본상",
        title: "dizzy",
        link: "https://youtu.be/_sJZjpW8LSQ?si=jdt4F9G39ueeEFnF",
        img: soundtrack2024Img7,
    },
    {
        award: "본상",
        title: "DPS",
        link: "https://youtu.be/GBJ7XsMeScU?si=W5WE-NbVv6To8YkT",
        img: soundtrack2024Img8,
    },
    {
        award: "본상",
        title: "Unknown Tree",
        link: "https://youtu.be/Pdew8ZPjyi0?si=YpF3ZRSqb3Zm1PZB",
        img: soundtrack2024Img9,
    },
    {
        award: "본상",
        title: "백안",
        link: "https://youtu.be/b4NFUkbfeRE?si=dgXzIQCKSZF_bqtH",
        img: soundtrack2024Img10,
    },
];

const soundTrackTabs = [
    { key: "2025", ordinal: "2", suffix: "nd" },
    { key: "2024", ordinal: "1", suffix: "st" },
] as const;
type SoundTrackTab = (typeof soundTrackTabs)[number]["key"];

export default function SoundTrack() {
    const [activeTab, setActiveTab] = useState<SoundTrackTab>("2025");

    return (
        <div>
            <div className="sticky top-[82px] z-[3] border-b border-[#ddd] bg-[#f1f4f9] xl:top-[117px]">
                <ul className="mx-auto flex w-full max-w-[1400px] items-center justify-center gap-[4px] md:gap-[60px]">
                    {soundTrackTabs.map(tab => {
                        const isActive = activeTab === tab.key;
                        return (
                            <li key={tab.key} className="flex">
                                <button
                                    type="button"
                                    onClick={() => setActiveTab(tab.key)}
                                    className={`flex items-center justify-center whitespace-nowrap border-b-[4px] py-3 font-['GongGothicBold'] text-[16px] leading-none tracking-[-0.32px] transition-colors md:py-[20px] md:text-[28px] md:tracking-[-0.56px] ${
                                        isActive
                                            ? "border-[#7c65db] text-[#7c65db]"
                                            : "border-transparent text-black hover:border-[#7c65db] hover:text-[#7c65db]"
                                    }`}
                                >
                                    <span>
                                        {tab.ordinal}
                                        <span className="align-super text-[10px] md:text-[18px]">{tab.suffix}</span>
                                        &nbsp;SOUND TRACK
                                    </span>
                                </button>
                            </li>
                        );
                    })}
                </ul>
            </div>
            <div className="overflow-x-hidden px-[20px] pt-[40px] md:pt-[60px] xl:px-0">
                {/* ============================ 2025 (The 2nd) ============================ */}
                <section
                    className={`mx-auto w-full max-w-[1400px] pb-[60px] md:pb-[80px] ${activeTab === "2025" ? "" : "hidden"}`}
                >
                    <TitleBox
                        title="SOUND TRACK"
                        text={
                            <div className="text-[28px] md:flex md:items-center md:justify-center md:text-[40px] xl:text-[60px]">
                                <p className="flex items-start justify-center">
                                    <span>The 2</span>
                                    <span className="align-super text-[18px] md:text-[24px] xl:text-[40px]">nd</span>
                                    <span>&nbsp;GXG&nbsp;</span>
                                </p>
                                <span>SOUND TRACK</span>
                            </div>
                        }
                    />
                    <div className="pt-[40px] md:pt-[60px] xl:flex xl:gap-[52px]">
                        <div className="aspect-[628/880] w-full max-w-[628px] shrink-0 xl:w-[628px]">
                            <img
                                src={soundtrack2025Poster}
                                alt="soundtrack 2025"
                                width={628}
                                height={880}
                                className="block h-full w-full object-cover"
                            />
                        </div>
                        <div className="w-full pt-[40px] xl:flex xl:flex-1 xl:flex-col xl:justify-between xl:pt-0">
                            <div className="hidden md:block">
                                <img
                                    src={soundtrack2025TxtImg}
                                    alt="The 2nd GXG SOUND TRACK"
                                    width={534}
                                    height={161}
                                    className="h-auto w-full max-w-[534px]"
                                />
                            </div>
                            <ul className="flex flex-col gap-[20px] md:gap-[24px] md:pt-[40px] xl:pt-0">
                                <li className="flex items-start gap-[12px] md:gap-[16px]">
                                    <p className="w-[76px] shrink-0 rounded-[8px] border border-[#E64C88] bg-[#ffffff14] py-[8px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[1.6] tracking-[-0.25px] text-black shadow-[0_0_12px_0_rgba(221,54,98,0.20)] md:w-[120px] md:text-[20px]">
                                        프로그램
                                    </p>
                                    <p className="flex-1 font-['GongGothicLight'] text-[16px] leading-[1.6] text-black md:text-[20px]">
                                        GXG 2025 게임음악 경연대회
                                        <br /> The 2<span className="align-super text-[0.7em]">nd</span> GXG SOUND TRACK
                                    </p>
                                </li>
                                <li className="flex items-center gap-[12px] md:gap-[16px]">
                                    <p className="w-[76px] shrink-0 rounded-[8px] border border-[#E64C88] bg-[#ffffff14] py-[8px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[1.6] tracking-[-0.25px] text-black shadow-[0_0_12px_0_rgba(221,54,98,0.20)] md:w-[120px] md:text-[20px]">
                                        모집기간
                                    </p>
                                    <p className="flex-1 font-['GongGothicLight'] text-[16px] leading-[1.6] text-black md:text-[20px]">
                                        2025.06.09(월) ~ 07.20(일)
                                    </p>
                                </li>
                                <li className="flex flex-col gap-[8px] md:gap-[16px]">
                                    <div className="flex items-start gap-[12px] md:gap-[16px]">
                                        <p className="w-[76px] shrink-0 rounded-[8px] border border-[#E64C88] bg-[#ffffff14] py-[8px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[1.6] tracking-[-0.25px] text-black shadow-[0_0_12px_0_rgba(221,54,98,0.20)] md:w-[120px] md:text-[20px]">
                                            경연주제
                                        </p>
                                        <p className="flex-1 font-['GongGothicLight'] text-[16px] leading-[1.6] text-black md:text-[20px]">
                                            16개 게임사 참여<span className="md:hidden">,</span>
                                            <br className="md:hidden" />
                                            <span className="hidden md:inline">&nbsp;</span>총 19개의 모티브 게임
                                        </p>
                                    </div>
                                    <div className="md:pl-[136px]">
                                        <div className="rounded-[8px] bg-white p-[8px] font-['GongGothicLight'] text-[14px] leading-[1.8] text-black md:p-[16px] md:text-[18px]">
                                            가디언테일즈, 검은사막, 나이트크로우, 던전앤파이터
                                            <br className="md:hidden" />
                                            유니버스, <br className="hidden md:block" />
                                            로스트아크, 리그오브레전드, 메이플스토리, <br className="md:hidden" />
                                            모바일한게임신맞고, <br className="hidden md:block" />
                                            모바일한게임포커, 브롤스타즈, <br className="md:hidden" />
                                            블루아카이브, 산나비, 아이온, 에픽세븐, <br className="hidden md:block" />
                                            오딘, <br className="md:hidden" />
                                            클래시로얄, 트릭컬리바이브, 배틀그라운드, P의거짓
                                        </div>
                                    </div>
                                </li>
                                <li className="flex flex-col gap-[8px] md:gap-[16px]">
                                    <div className="flex items-start gap-[12px] md:gap-[16px]">
                                        <p className="w-[76px] shrink-0 rounded-[8px] border border-[#E64C88] bg-[#ffffff14] py-[8px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[1.6] tracking-[-0.25px] text-black shadow-[0_0_12px_0_rgba(221,54,98,0.20)] md:w-[120px] md:text-[20px]">
                                            시상부문
                                        </p>
                                        <p className="flex-1 font-['GongGothicLight'] text-[16px] leading-[1.6] text-black md:text-[20px]">
                                            시상부문 4개(7팀) / <br className="md:hidden" />
                                            총상금 2,200만원
                                        </p>
                                    </div>
                                    <div className="md:pl-[136px]">
                                        <ul className="flex flex-col gap-[8px] rounded-[8px] bg-white p-[8px] text-black md:flex-row md:flex-wrap md:justify-center md:gap-x-[10px] md:gap-y-[8px] md:p-[16px]">
                                            <li className="flex items-center gap-[8px] md:w-[calc(50%-5px)]">
                                                <img src={icAward1} alt="대상" className="size-[28px]" />
                                                <p className="font-['GongGothicMedium'] text-[18px] md:text-[20px]">
                                                    대상
                                                </p>
                                                <p className="font-['GongGothicLight'] text-[16px] md:text-[20px]">
                                                    1,000만원(1팀)
                                                </p>
                                            </li>
                                            <li className="flex items-center gap-[8px] md:w-[calc(50%-5px)]">
                                                <img src={icAward2} alt="금상" className="size-[28px]" />
                                                <p className="font-['GongGothicMedium'] text-[18px] md:text-[20px]">
                                                    금상
                                                </p>
                                                <p className="font-['GongGothicLight'] text-[16px] md:text-[20px]">
                                                    500만원(1팀)
                                                </p>
                                            </li>
                                            <li className="flex items-center gap-[8px] md:w-[calc(50%-5px)]">
                                                <img src={icAward3} alt="은상" className="size-[28px]" />
                                                <p className="font-['GongGothicMedium'] text-[18px] md:text-[20px]">
                                                    은상
                                                </p>
                                                <p className="font-['GongGothicLight'] text-[16px] md:text-[20px]">
                                                    200만원(2팀)
                                                </p>
                                            </li>
                                            <li className="flex items-center gap-[8px] md:w-[calc(50%-5px)]">
                                                <img src={icAward4} alt="동상" className="size-[28px]" />
                                                <p className="font-['GongGothicMedium'] text-[18px] md:text-[20px]">
                                                    동상
                                                </p>
                                                <p className="font-['GongGothicLight'] text-[16px] md:text-[20px]">
                                                    100만원(3팀)
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>
                <section
                    className={`mx-auto w-full max-w-[1400px] pb-[120px] md:pb-[160px] ${activeTab === "2025" ? "" : "hidden"}`}
                >
                    <SubTitle title="경연대회 본선 무대 (2025)" className="pb-[24px] md:pb-[40px]" />
                    <ul className="grid grid-cols-1 gap-y-[24px] md:grid-cols-2 md:gap-x-[20px] md:gap-y-[40px]">
                        {stage2025LargeList.map((item, i) => (
                            <li key={`stage_large_${i}`}>
                                <StageCard item={item} large />
                            </li>
                        ))}
                    </ul>
                    <ul className="mt-[24px] grid grid-cols-1 gap-y-[24px] md:mt-[40px] md:grid-cols-2 md:gap-x-[20px] md:gap-y-[40px] xl:grid-cols-3">
                        {stage2025SmallList.map((item, i) => (
                            <li key={`stage_small_${i}`}>
                                <StageCard item={item} />
                            </li>
                        ))}
                    </ul>
                </section>

                {/* ============================ 2024 (The 1st) ============================ */}
                <section
                    className={`mx-auto w-full max-w-[1400px] pb-[60px] md:pb-[80px] ${activeTab === "2024" ? "" : "hidden"}`}
                >
                    <TitleBox
                        title="SOUND TRACK"
                        text={
                            <div className="text-[28px] md:flex md:items-center md:justify-center md:text-[40px] xl:text-[60px]">
                                <p className="flex items-start justify-center">
                                    <span>The 1</span>
                                    <span className="align-super text-[18px] md:text-[24px] xl:text-[40px]">st</span>
                                    <span>&nbsp;GXG&nbsp;</span>
                                </p>
                                <span>SOUND TRACK</span>
                            </div>
                        }
                    />
                    <div className="pt-[40px] md:pt-[60px] xl:flex xl:gap-[52px]">
                        <div>
                            <img src={soundtrackPoster} alt="soundtrack" />
                        </div>
                        <div className="w-full pt-[40px] xl:flex xl:flex-1 xl:flex-col xl:justify-between xl:pt-0">
                            <div className="hidden md:block">
                                <img src={soundtrackTxtImg} alt="soundtrack" />
                            </div>
                            <ul className="flex flex-col gap-[12px] md:gap-[16px] md:pt-[40px] xl:pt-0">
                                <li className="flex items-start gap-[12px] md:gap-[16px]">
                                    <p className="w-full max-w-[76px] rounded-[8px] border border-transparent py-[2px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[38px] text-[#000] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] [background-clip:padding-box,border-box] [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] md:max-w-[120px] md:py-[4px] md:text-[20px]">
                                        프로그램
                                    </p>
                                    <p className="flex-1 font-['GongGothicLight'] text-[16px] font-medium leading-[1.8] text-black md:text-[20px]">
                                        GXG 2024 게임음악 경연대회
                                        <br /> The 1<span className="align-super text-[0.7em]">st</span> GXG SOUND TRACK
                                    </p>
                                </li>
                                <li className="flex items-center gap-[12px] md:gap-[16px]">
                                    <p className="w-full max-w-[76px] rounded-[8px] border border-transparent py-[2px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[38px] text-[#000] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] [background-clip:padding-box,border-box] [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] md:max-w-[120px] md:py-[4px] md:text-[20px]">
                                        모집기간
                                    </p>
                                    <p className="flex-1 font-['GongGothicLight'] text-[16px] font-medium leading-[1.8] text-black md:text-[20px]">
                                        2024년 6월 7일(금)~7월 21일(일)
                                    </p>
                                </li>
                                <li className="flex items-start gap-[12px] md:gap-[16px]">
                                    <p className="w-full max-w-[76px] rounded-[8px] border border-transparent py-[2px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[38px] text-[#000] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] [background-clip:padding-box,border-box] [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] md:max-w-[120px] md:py-[4px] md:text-[20px]">
                                        경연주제
                                    </p>
                                    <div className="flex flex-1 flex-col gap-[8px]">
                                        <p className="font-['GongGothicLight'] text-[16px] font-medium leading-[1.8] text-black md:py-[6px] md:text-[20px]">
                                            10개 게임사 참여, <br className="md:hidden" />총 12개의 모티브 게임
                                        </p>
                                        <div className="-ml-[88px] w-[calc(100%+88px)] bg-white p-[8px] font-['GongGothicLight'] text-[14px] leading-[1.8] text-black md:ml-0 md:w-full md:p-[16px] md:text-[20px]">
                                            가디언 테일즈, 검은사막, 던전앤파이터 모바일, <br className="xl:hidden" />
                                            로스트아크, 리그오브레전드, 리니지, 메이플스토리,{" "}
                                            <br className="xl:hidden" />
                                            모바일 한게임 신맞고, <br className="hidden xl:block" />
                                            모바일 한게임 포커, 에픽세븐, <br className="xl:hidden" />
                                            PUBG: 배틀그라운드, P의 거짓
                                        </div>
                                    </div>
                                </li>
                                <li className="flex items-start gap-[12px] md:gap-[16px]">
                                    <p className="w-full max-w-[76px] rounded-[8px] border border-transparent py-[2px] text-center font-['GongGothicMedium'] text-[18px] font-[500] leading-[38px] text-[#000] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] [background-clip:padding-box,border-box] [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] md:max-w-[120px] md:py-[4px] md:text-[20px]">
                                        시상부문
                                    </p>
                                    <div className="flex flex-1 flex-col gap-[8px]">
                                        <p className="font-['GongGothicLight'] text-[16px] font-medium leading-[1.8] text-black md:py-[6px] md:text-[20px]">
                                            시상 부문 5개(10팀) / <br className="md:hidden" />
                                            총상금 2,300만원
                                        </p>
                                        <ul className="-ml-[88px] flex w-[calc(100%+88px)] flex-col gap-[8px] bg-white p-[8px] leading-[1.5] text-black md:ml-0 md:w-full md:flex-row md:flex-wrap md:gap-x-[10px] md:gap-y-[8px] md:p-[16px] md:[&>li>p]:text-[20px]">
                                            <li className="flex items-center gap-[8px] md:w-[calc(50%-5px)]">
                                                <img src={icAward1} alt="대상" />
                                                <p className="font-['GongGothicMedium'] text-[18px]">대상</p>
                                                <p className="font-['GongGothicLight']">1,000만원(1팀)</p>
                                            </li>
                                            <li className="flex items-center gap-[8px] md:w-[calc(50%-5px)]">
                                                <img src={icAward2} alt="금상" />
                                                <p className="font-['GongGothicMedium'] text-[18px]">금상</p>
                                                <p className="font-['GongGothicLight']">500만원(1팀)</p>
                                            </li>
                                            <li className="flex items-center gap-[8px] md:w-[calc(50%-5px)]">
                                                <img src={icAward3} alt="은상" />
                                                <p className="font-['GongGothicMedium'] text-[18px]">은상</p>
                                                <p className="font-['GongGothicLight']">200만원(2팀)</p>
                                            </li>
                                            <li className="flex items-center gap-[8px] md:w-[calc(50%-5px)]">
                                                <img src={icAward4} alt="동상" />
                                                <p className="font-['GongGothicMedium'] text-[18px]">동상</p>
                                                <p className="font-['GongGothicLight']">100만원(2팀)</p>
                                            </li>
                                            <li className="flex items-center gap-[8px] md:w-[calc(50%-5px)]">
                                                <img src={icAward5} alt="본상" />
                                                <p className="font-['GongGothicMedium'] text-[18px]">본상</p>
                                                <p className="font-['GongGothicLight']">50만원(4팀)</p>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>
                <section
                    className={`mx-auto w-full max-w-[1400px] pb-[120px] md:pb-[160px] ${activeTab === "2024" ? "" : "hidden"}`}
                >
                    <SubTitle title="경연대회 본선 무대 (2024)" className="pb-[24px] md:pb-[40px]" />
                    <ul className="flex flex-col gap-[40px] md:flex-row md:flex-wrap md:gap-[40px] xl:gap-x-[20px] xl:gap-y-[40px]">
                        {awardList.map((item, i) => (
                            <li
                                key={`img_${i}`}
                                className={`w-full ${i > 1 ? "md:w-[calc(50%-20px)] xl:w-[calc(25%-15px)]" : "xl:w-[calc(50%-10px)]"}`}
                            >
                                <div className="cursor-pointer">
                                    <div className="group relative aspect-video w-full">
                                        <div className="absolute inset-0 z-[2] rounded-[20px_0_20px_0] transition-all duration-500 after:absolute after:inset-0 after:z-[1] after:rounded-[20px_0_20px_0] after:bg-[linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] after:opacity-0 after:transition-all after:duration-500 after:content-[''] group-hover:p-[4px] group-hover:shadow-[0_0_36px_0_rgba(237,6,115,0.60)] group-hover:after:opacity-100">
                                            <div className="relative z-[2] h-full w-full overflow-hidden rounded-[20px_0_20px_0]">
                                                <a
                                                    href={item.link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="relative block after:absolute after:inset-0 after:z-[1] after:bg-[rgba(0,0,0,0.4)] after:opacity-0 after:transition-all after:duration-500 after:content-[''] hover:after:opacity-100"
                                                >
                                                    <img
                                                        src={item.img}
                                                        alt={item.title}
                                                        className="h-full w-full object-cover transition-all duration-500 xl:group-hover:scale-[1.2]"
                                                    />
                                                    <p className="absolute left-1/2 top-1/2 z-[2] flex -translate-x-1/2 -translate-y-1/2 items-center justify-center gap-[12px] font-['GongGothicMedium'] text-[24px] text-white opacity-0 transition-all duration-500 group-hover:opacity-100">
                                                        다시보기
                                                        <img src={arrowOutwardWhite} alt="다시보기" />
                                                    </p>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-[16px] pt-[16px]">
                                        <div className="w-full max-w-[72px] rounded-[8px] border border-transparent py-[2px] text-center font-['GongGothicMedium'] text-[20px] font-[500] leading-[38px] text-[#000] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] [background-clip:padding-box,border-box] [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] md:max-w-[120px] md:py-[4px] md:text-[20px]">
                                            <p
                                                style={{
                                                    background: `${item.award === "대상" ? "linear-gradient(180deg, #EB0771 0%, #850440 100%)" : item.award === "금상" ? "linear-gradient(180deg, #EB8E03 0%, #855002 100%)" : item.award === "은상" ? "linear-gradient(180deg, #9C8E8E 0%, #363131 100%)" : item.award === "동상" ? "linear-gradient(180deg, #654F42 0%, #CB9E84 100%)" : "black"}`,
                                                    backgroundClip: "text",
                                                    WebkitBackgroundClip: "text",
                                                    WebkitTextFillColor: "transparent",
                                                }}
                                            >
                                                {item.award}
                                            </p>
                                        </div>
                                        <p className="font-['GongGothicLight'] text-[20px]">{item.title}</p>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </section>
            </div>
        </div>
    );
}
